import * as React from "react";
import DialogMui from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "../Button";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const CloseIconObj = {
    label: "Close",
    type: "button",
};
export const Dialog = (props) => {
    const [open, setOpen] = React.useState(props.show);
    React.useEffect(() => {
        setOpen(props.show);
    }, [props.show]);
    if (!open)
        return null;
    const handleClose = (btn, reason) => {
        if (reason && reason == "backdropClick")
            return;
        handleClickEvents(btn);
    };
    const handleClickEvents = (btn) => {
        setOpen(false);
        props.handleCallback(Object.assign({}, btn));
    };
    const { title, buttons } = props;
    return (React.createElement(DialogMui, { open: open, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", className: `mui-${props.brand}` },
        title && (React.createElement(DialogTitle, { sx: Object.assign(Object.assign({}, props.titleBackgroundColor), { fontSize: props.CloseIcon ? "1.5rem" : "16px", color: "#000", fontWeight: "400" }), id: "alert-dialog-title" },
            title,
            open && props.CloseIcon ? (React.createElement(IconButton, { "aria-label": "close", onClick: () => handleClickEvents(CloseIconObj), sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => props.CloseIconColor
                        ? props.CloseIconColor
                        : theme.palette.grey[500],
                } },
                React.createElement(CloseIcon, null))) : null)),
        React.createElement(DialogContent, { dividers: props.CloseIcon },
            React.createElement(props.body, null)),
        React.createElement(DialogActions, null, buttons.map((btn) => (React.createElement(Button, Object.assign({ key: btn.label }, btn, { onClick: () => handleClickEvents(btn) })))))));
};
